import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-talmud',
  imports: [Link],
  templateUrl: './talmud.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './talmud.scss',
})
export class Talmud {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Talmud`);
    this.dynamicTitle.description(`The Talmud's portrayal of Yeshu is not consistent with the accounts found in the New Testament, and it does not provide evidence for Jesus's existence.`);
  }
}
